import script from "./ChatbotAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotAssistant.vue?vue&type=script&setup=true&lang=js"

import "./ChatbotAssistant.vue?vue&type=style&index=0&id=4c0fbdee&scoped=true&lang=css"
import "./ChatbotAssistant.vue?vue&type=style&index=1&id=4c0fbdee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0fbdee"]])

export default __exports__